import React, { useMemo } from 'react';
import { DateTime } from 'luxon';
import PropTypes from "prop-types"

/**
 * Convert time range such as 08-16 Helsinki time into detected local timezone
 */
const HoursRangeConverter = ({ range = "08-16", timeZone = "Europe/Helsinki" }) => {
  
  const localizedTime = useMemo(() => {
    const [startHour, endHour] = range.split('-').map(Number);

    const inputStart = DateTime.fromObject({ hour: startHour }, { zone: timeZone });
    const inputEnd = DateTime.fromObject({ hour: endHour }, { zone: timeZone });

    return {
      start: inputStart.toLocal().toFormat('HH:mm'),
      end: inputEnd.toLocal().toFormat('HH:mm'),
      userZoneName: DateTime.local().zoneName
    };
  }, [range, timeZone]);

  return (
    <span>{localizedTime.start}–{localizedTime.end}</span>
  );
};

HoursRangeConverter.propTypes = {
  range: PropTypes.string,
  timeZone: PropTypes.string,
}

export default HoursRangeConverter;